import { render, staticRenderFns } from "./DocumentEsdhExportChild.vue?vue&type=template&id=c8692036&scoped=true&"
import script from "./DocumentEsdhExportChild.vue?vue&type=script&lang=ts&"
export * from "./DocumentEsdhExportChild.vue?vue&type=script&lang=ts&"
import style0 from "./DocumentEsdhExportChild.vue?vue&type=style&index=0&id=c8692036&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8692036",
  null
  
)

export default component.exports